<template>
  <div>
      <navigation />
    <register
      v-if="!isLogin"
    />
    <applySiteBaseInfo
      v-if="isLogin"
    />
    </div>

</template>

<script>
  import register from './register.vue'
  import applySiteBaseInfo from './applySiteBaseInfo.vue'
  import navigation from './navigation'
  import utilAPi from '../assets/js/utils'
  export default {
    name: 'sign-apply',
    components: {
      'navigation': navigation, register,applySiteBaseInfo
    },
    created() {
      this.getUserInfo()
    },
    data() {
      return {
        isLogin: false
      }
    },
    methods: {
      getUserInfo() {
        let _self = this
        _self.axios.get(
          _self.api.getUserInfo
        ).then(res => {
          if (res.data.code === 10000) {
            this.isLogin = true
          } else {
            this.isLogin = false
          }
        }).catch(err => {
          this.$message.error('网络请求异常!')
        })
      }
    }
  }
</script>

<style scoped="scoped">

</style>



// WEBPACK FOOTER //
// src/components/signApply.vue